import { gql } from '@apollo/client'

export const GET_PRODUCT_ATTRIBUTES = gql`
  query getProductAttributes($id: uuid!) {
    product: products_by_pk(id: $id) {
      id
      attributes
    }
  }
`

export const UPDATE_ATTRIBUTE = gql`
  mutation updateProductAttributes($id: uuid!, $attribute: jsonb) {
    update_products(
      where: { id: { _eq: $id } }
      _append: { attributes: $attribute }
    ) {
      affected_rows
      returning {
        id
        attributes
      }
    }
  }
`

export const REMOVE_ATTRIBUTE = gql`
  mutation removeProductAttribute($id: uuid!, $key: String!) {
    update_products(
      where: { id: { _eq: $id } }
      _delete_key: { attributes: $key }
    ) {
      affected_rows
      returning {
        id
        attributes
      }
    }
  }
`
